/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountCurrentNicknameUpdateRequest model module.
 * @module model/AccountControllerDtoAccountCurrentNicknameUpdateRequest
 * @version 1.0
 */
class AccountControllerDtoAccountCurrentNicknameUpdateRequest {
    /**
     * Constructs a new <code>AccountControllerDtoAccountCurrentNicknameUpdateRequest</code>.
     * @alias module:model/AccountControllerDtoAccountCurrentNicknameUpdateRequest
     */
    constructor() { 
        
        AccountControllerDtoAccountCurrentNicknameUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountCurrentNicknameUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountCurrentNicknameUpdateRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountCurrentNicknameUpdateRequest} The populated <code>AccountControllerDtoAccountCurrentNicknameUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountCurrentNicknameUpdateRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('oldNickname')) {
                obj['oldNickname'] = ApiClient.convertToType(data['oldNickname'], 'String');
            }
            if (data.hasOwnProperty('newNickname')) {
                obj['newNickname'] = ApiClient.convertToType(data['newNickname'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountCurrentNicknameUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountCurrentNicknameUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['oldNickname'] && !(typeof data['oldNickname'] === 'string' || data['oldNickname'] instanceof String)) {
            throw new Error("Expected the field `oldNickname` to be a primitive type in the JSON string but got " + data['oldNickname']);
        }
        // ensure the json data is a string
        if (data['newNickname'] && !(typeof data['newNickname'] === 'string' || data['newNickname'] instanceof String)) {
            throw new Error("Expected the field `newNickname` to be a primitive type in the JSON string but got " + data['newNickname']);
        }

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountCurrentNicknameUpdateRequest.prototype['accountNo'] = undefined;

/**
 * @member {String} oldNickname
 */
AccountControllerDtoAccountCurrentNicknameUpdateRequest.prototype['oldNickname'] = undefined;

/**
 * @member {String} newNickname
 */
AccountControllerDtoAccountCurrentNicknameUpdateRequest.prototype['newNickname'] = undefined;






export default AccountControllerDtoAccountCurrentNicknameUpdateRequest;

